import { TextInput, OutlinedButton } from '../../../components';

const SignInForm = ({
  username,
  password,
  error,
  usernameError,
  passwordError,
  onUsernameChange,
  onPasswordChange,
  onLogin,
  onResetErrors
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(); // This should call the handleLogin function
  };

  // Add a click handler as fallback
  const handleButtonClick = (e) => {
    // Prevent default to avoid double submission
    e.preventDefault();
    onLogin();
  };

  return (
    <div className="signInInfo">
      <p className="header">Sign in</p>
      <p className="subheader">Sign in to Credipple</p>
      
      <form onSubmit={handleSubmit} noValidate>
        <TextInput
          type="text"
          label="Username"
          variant="standard"
          placeholder="name@company.co.za"
          style={{ width: '70%', marginBottom: '30px' }}
          onChange={onUsernameChange}
          value={username}
          error={usernameError}
          onFocus={onResetErrors}
          autoComplete="username"
          required
        />
        
        <TextInput
          label="Password"
          variant="standard"
          placeholder="******"
          type="password"
          style={{ width: '70%' }}
          onChange={onPasswordChange}
          value={password}
          error={passwordError}
          onFocus={onResetErrors}
          autoComplete="current-password"
          required
        />
        
        {error && <p className="errorText" role="alert">{error}</p>}
        
        <p className="forgotPasswordDesc">
          Forgot your password?{' '}
          <span className="forgotPasswordLink">Reset password</span>
        </p>
        
        <OutlinedButton
          type="submit"
          style={{ width: '70%', marginTop: '60px' }}
          onClick={handleButtonClick} // Added onClick as fallback
        >
          Sign In
        </OutlinedButton>
      </form>
    </div>
  );
};

export default SignInForm;